import { ServiceResponse } from "../service-response";
import axios from "axios";
const WORKER_ENDPOINT = process.env.REACT_APP_WORKER_ENDPOINT || "https://safe-alpha-worker.codynhat.workers.dev";
console.log('WORKER_ENDPOINT', WORKER_ENDPOINT);
export class ApiServiceImpl {
    constructor() {
        this.urls = {
            worker: WORKER_ENDPOINT,
        };
    }
    success(data) {
        return new ServiceResponse({ data });
    }
    error(error) {
        console.error("Error: ", error);
        return new ServiceResponse({ error });
    }
    get(url, params, headers) {
        let urlWithQuery = url;
        if (params) {
            urlWithQuery = urlWithQuery + "?";
            Object.keys(params).map((key, index) => (urlWithQuery = `${urlWithQuery}${index ? "&" : ""}${key}=${params[key]}`));
        }
        return axios.get(urlWithQuery, headers);
    }
    post(url, data, headers) {
        let urlWithQuery = url;
        return axios.post(urlWithQuery, data, { headers: headers });
    }
}
